/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

/**
 * @description this component expects a
 * 'title' as props and a list of children.
 * To have a custom action in header it's
 * necessary to add a child with key 'headerAction'
 */
class ModalWindow extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    Modal.setAppElement('body');
  }

  titleText() {
    const { title, subtitle, details } = this.props;
    return title ? (
      <div className="modal-header-title pull-left">
        <h3 className="modal-title">{title}</h3>
        {subtitle && <h3 className="modal-subtitle">{subtitle}</h3>}
        <p className="modal-details" title={details}>
          {details}
        </p>
      </div>
    ) : null;
  }

  getAction() {
    const children = this.props.children;
    return (
      <div className="modal-header-action pull-right">
        {React.Children.map(children, (child, i) => {
          if (child !== 'undefined' && child !== null && child.key == 'headerAction') {
            return child;
          }
        })}
      </div>
    );
  }

  render() {
    const { isOpen, shouldCloseOnOverlayClick, title, className, children, id } = this.props;
    return (
      <div>
        <Modal
          isOpen={isOpen}
          contentLabel={title}
          shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
          overlayClassName="modal-overlay crf"
          className={className ? className : 'modal-dialog'}
        >
          <div id={id} className="modal-content">
            <div className="modal-header">
              {this.titleText()}
              {this.getAction()}
            </div>
            <div className="modal-body">
              {React.Children.map(children, (child, i) => {
                if (child !== 'undefined' && child !== null && child.key != 'headerAction') {
                  return child;
                }
              })}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

ModalWindow.propTypes = {
  isOpen: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

export default ModalWindow;
